/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Outlet, RouteObject } from "react-router-dom";

import { ProtectedRoute } from "../../components/AppRouter/ProtectedRoute";
import { CampaignSuccess } from "../../pages/CampaignSuccess";
import { DrawdownSuccess } from "../../pages/DrawdownSuccessV2";
import SalesAgreements from "../../pages/SalesAgreements";
import { HOME_ROUTE } from "../../util/routing";

import {
  AGREEMENT_CAMPAIGN_SUCCESS_ROUTE,
  AGREEMENT_DETAIL_ROUTE,
  AGREEMENT_DRAWDOWN_ROUTE,
  AGREEMENTS_ROUTES,
} from "./constants";
import SalesAgreement from "./SalesAgreement";

export const salesAgreementRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute
        mode="single"
        permission="SalesAgreements_AgreementView"
        redirectTo={HOME_ROUTE}
      >
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { path: AGREEMENTS_ROUTES.BASE, element: <SalesAgreements /> },
      { path: AGREEMENT_DETAIL_ROUTE, element: <SalesAgreement /> },
      { path: AGREEMENT_DRAWDOWN_ROUTE, element: <DrawdownSuccess /> },
      { path: AGREEMENT_CAMPAIGN_SUCCESS_ROUTE, element: <CampaignSuccess /> },
    ],
  },
];
